module.exports = __webpack_public_path__ + "static/media/YF106_2.5669ca0a.jpg";